import { useCallback, useRef } from 'react'

interface LongPressOptions {
  onLongPress: () => void
  duration?: number
}

export function useLongPress({
  onLongPress,
  duration = 5000,
}: LongPressOptions) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const startPress = useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      onLongPress()
    }, duration)
  }, [onLongPress, duration])

  const endPress = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  return {
    onMouseDown: startPress,
    onMouseUp: endPress,
    onMouseLeave: endPress,
  }
}
